import {Component, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';
import {combineLatest, Subject} from 'rxjs';
import {FormBuilder, Validators} from '@angular/forms';
import {UploaderComponent} from '../../../shared/uploader/uploader.component';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
import {debounceTime, takeUntil} from 'rxjs/operators';
import {RootService} from 'src/app/services/root.service';
import {BusinessCodeService} from 'src/app/services/business/business-code/business-code.service';
import {DocumentsService} from 'src/app/services/business/documents/documents.service';
import {NzNotificationService} from 'ng-zorro-antd/notification';
import {capitalizeFirstLetter, removeAllSpacingBetweenWords} from '../../../helpers';

@Component({
  selector: 'app-business-code-add',
  templateUrl: './business-code-add.component.html',
  styleUrls: ['./business-code-add.component.scss']
})
export class BusinessCodeAddComponent implements OnInit {
  countries = [];
  addressDisplay = '';
  cities = [];
  districts = [];
  files: any[] = [];
  unsubscribe$ = new Subject<void>();
  show = false;
  avatar = [];
  cover = [];
  name = ''
  code = ''
  glncode = ''
  tax = ''
  address = ''
  phoneNumber = ''
  website = ''
  emailText = ''
  // tslint:disable-next-line:variable-name
  form_create = this.fb.group({
    name: ['', Validators.required],
    enterpriseCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
    glnCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
    taxCode: ['', [Validators.required, Validators.pattern('[a-zA-Z0-9]*')]],
    countryId: ['', Validators.required],
    address: ['', Validators.required],
    city: ['', Validators.required],
    district: ['', Validators.required],
    phone: ['', Validators.pattern('[0-9]*')],
    email: ['', Validators.pattern('[a-z0-9_\\.]{1,32}@[a-z0-9]{2,}(\\.[a-z0-9]{2,4}){1,2}$')],
    website: [''],
    avatar: [''],
    cover: [''],
    documents: [this.fb.control([]), [Validators.required]],
    addressNewName: [null, [Validators.maxLength(255)]],
    provinceNewId: [null, [Validators.required]],
    wardNewId: [null, [Validators.required]],
    addressNew: [true],
  });
  notDocuments = false;
  validName = false;
  validenterpriseCode = false;
  validGlnCode = false;
  validTaxCode = false;
  validAddress = false;
  messGLN = '';
  country_id;
  country_code: any;
  cityNew: any = [];
  listWard: any = [];

  @Output() emitData = new EventEmitter();
  // @ts-ignore
  @ViewChild('selectDocument') selectDocument;
  // @ts-ignore
  @ViewChild('createDocument') createDocument;
  loading = false;

  constructor(
    private  fb: FormBuilder,
    private notification: NzNotificationService,
    private modalService: NzModalService,
    private rootService: RootService,
    private codeService: BusinessCodeService,
    private docService: DocumentsService,
  ) {
  }

  ngOnInit() {


    this.notification.config({
      nzPlacement: 'bottomRight'
    });
    this.form_create.controls.city.clearValidators();
    this.form_create.controls.city.disable();
    this.form_create.controls.district.clearValidators();
    this.form_create.controls.district.disable();
    this.form_create.controls.provinceNewId.clearValidators();
    this.form_create.controls.provinceNewId.disable();

    this.form_create.controls.wardNewId.clearValidators();
    this.form_create.controls.wardNewId.disable();
    // console.log("this.form_create", this.form_create.value)
    // this.form_create.get('addressNew').setValue(true);
    this.form_create.get('addressNew').valueChanges
      .subscribe(addressNew => {
        console.log('addressNew hẹ hẹ', addressNew);
        this.updateAddressValidation(this.form_create.get('addressNew').value);
      });

    // Chỉ log khi cả 3 giá trị province_id, district_id, address đều có
    combineLatest([
      this.form_create.get('city').valueChanges,
      this.form_create.get('district').valueChanges,
      this.form_create.get('address').valueChanges,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([provinceId, districtId, address]) => {
        if (provinceId && districtId && address) {
          const query = {
            type: 1,
            parentId: 0,
            cityOldId: provinceId,
            // wardOldId: districtId
          };
          this.rootService.getLocationOld(query).subscribe(res => {
            // console.log("res", res)
            if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
              this.addressDisplay = [address, res.data.cityNew.name].join(', ');
            }
          });
        } else {
          this.addressDisplay = '';
        }
      });


    this.rootService.getLocationNew({
      type: 1
    }).subscribe((res) => {
      // console.log("res", res)
      this.cityNew = res.data.data;
      // console.log("this.city2", this.cityNew)
    });

    this.form_create.get('provinceNewId').valueChanges.pipe(debounceTime(500)).subscribe(val => {
      if (val) {
        this.rootService.getLocationNew({
          type: 2,
          parentId: val
        }).subscribe((res: any) => {
          if (res.code === 1) {
            this.listWard = res && res.data && res.data.data ?  res.data.data : [];
          }
        });
      }
    });
  }

  updateAddressValidation(addressNew: boolean) {
    if (addressNew) {
      // Khi addressNew = true: bỏ required cho province_id, district_id, streetId, address
      this.form_create.get('city').clearValidators();
      this.form_create.get('district').clearValidators();
      this.form_create.get('address').clearValidators();

      // Thêm required cho addressNewName, provinceNewId, wardNewId
      this.form_create.get('addressNewName').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form_create.get('provinceNewId').setValidators([Validators.required]);
      this.form_create.get('wardNewId').setValidators([Validators.required]);
    } else {
      // Khi addressNew = false: thêm required cho province_id, district_id, streetId, address
      this.form_create.get('city').setValidators([Validators.required]);
      this.form_create.get('district').setValidators([Validators.required]);
      this.form_create.get('address').setValidators([Validators.required, Validators.maxLength(255)]);

      // Bỏ required cho addressNewName, provinceNewId, wardNewId
      this.form_create.get('addressNewName').clearValidators();
      this.form_create.get('provinceNewId').clearValidators();
      this.form_create.get('wardNewId').clearValidators();
    }

    // Cập nhật validation cho tất cả các field
    this.form_create.get('city').updateValueAndValidity();
    this.form_create.get('district').updateValueAndValidity();
    this.form_create.get('address').updateValueAndValidity();
    this.form_create.get('addressNewName').updateValueAndValidity();
    this.form_create.get('provinceNewId').updateValueAndValidity();
    this.form_create.get('wardNewId').updateValueAndValidity();
  }

  modalDocument() {
    this.selectDocument.setCheckboxAll();
    this.files.map((res) => {
      this.selectDocument.setId(res.documentId, true);
    });
    this.selectDocument.showModal();
  }

  newDocument(event) {
    event.title = capitalizeFirstLetter(removeAllSpacingBetweenWords(event.title));
    this.docService.create(event).subscribe(
      res => {
        if (res.code === 1) {
          this.createDocument.hide();
          const data = {
            documentId: res.data.documentId,
            title: res.data.title !== null &&  res.data.title.length > 100 ? res.data.title.slice(0, 100) + '...' : res.data.title
          };
          this.files.push(data);
          this.notDocuments = false;
          this.files.map((item) => {
            this.selectDocument.setId(item.documentId, true);
          });
          return;
        }
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          res.message
        );
      },
      error => {
        this.notification.create(
          'error',
          'Thêm giấy tờ thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  selectDocuments(event) {
    const newList = [];
    event.ids.map((item, key) => {
      const data = {
        documentId: item,
        title: event.titles[key] !== null && event.titles[key].length > 100 ? event.titles[key].slice(0, 100) + '...' : event.titles[key]
      };
      newList.push(data);
    });
    this.files = newList;
    this.notDocuments = this.files.length <= 0;
    this.selectDocument.handleCancel();
    return;
  }

  inputChange(event) {
    this[event] = false;
  }
  citiChange(event) {
    if (event === null) {
        this.form_create.controls.city.clearValidators();
        this.form_create.controls.city.disable();
        this.form_create.controls.district.clearValidators();
        this.form_create.controls.district.disable();
        this.form_create.controls.provinceNewId.clearValidators();
        this.form_create.controls.provinceNewId.disable();
        this.form_create.controls.wardNewId.clearValidators();
        this.form_create.controls.wardNewId.disable();

      this.form_create.controls.city.setValue(null);
      this.form_create.controls.district.setValue(null);
      this.form_create.controls.provinceNewId.setValue(null);
      this.form_create.controls.wardNewId.setValue(null);

        return;
    }
    this.country_code = event.split('-')[1];
    if (this.country_code  !== 'VN') {
      this.form_create.controls.city.clearValidators();
      this.form_create.controls.city.disable();
      this.form_create.controls.district.clearValidators();
      this.form_create.controls.district.disable();
      this.form_create.controls.provinceNewId.clearValidators();
      this.form_create.controls.provinceNewId.disable();
      this.form_create.controls.wardNewId.clearValidators();
      this.form_create.controls.wardNewId.disable();

      this.form_create.controls.city.setValue(null);
      this.form_create.controls.district.setValue(null);
      this.form_create.controls.provinceNewId.setValue(null);
      this.form_create.controls.wardNewId.setValue(null);
      return;
    }
    this.form_create.controls.city.setValidators(Validators.required);
    this.form_create.controls.city.enable();
    this.form_create.controls.district.setValidators(Validators.required);
    this.form_create.controls.district.enable();
    this.form_create.controls.provinceNewId.setValidators(Validators.required);
    this.form_create.controls.provinceNewId.enable();
    this.form_create.controls.wardNewId.setValidators(Validators.required);
    this.form_create.controls.wardNewId.enable();
  }
  create() {
    this.messGLN = '';
    this.validName = false;
    this.validenterpriseCode = false;
    this.validGlnCode = false;
    this.validTaxCode = false;
    this.validAddress = false;

    if (this.files.length) {
      const docs = [];
      this.files.map(item => {
        docs.push(item.documentId);
      });
      this.form_create.get('documents').setValue(docs);
    } else {
      this.notDocuments = true;
    }
    // tslint:disable-next-line:forin
    for (const i in this.form_create.controls) {
      this.form_create.controls[i].markAsDirty();
      this.form_create.controls[i].updateValueAndValidity();
    }
    if (this.form_create.invalid) {
      return;
    }
    const name$ = this.form_create.value.name;
    const enterpriseCode$ = this.form_create.value.enterpriseCode;
    const glnCode$ = this.form_create.value.glnCode;
    const taxCode$ = this.form_create.value.taxCode;
    const countryId$ = this.form_create.value.countryId.split('-')[1];
    const address$ = this.form_create.value.address;
    if (!name$.trim()) {
      this.validName = true;
    }
    if (!enterpriseCode$.trim()) {
      this.validenterpriseCode = true;
    }
    if (!glnCode$.trim()) {
      this.messGLN = 'Mã GLN không hợp lệ';
      this.validGlnCode = true;
    }
    const gln = glnCode$.substr(0, enterpriseCode$.length);
    // tslint:disable-next-line:triple-equals
    if (gln != enterpriseCode$ && glnCode$.trim()) {
      this.messGLN = 'GLN phải có prefix trùng với mã doanh nghiệp';
      this.validGlnCode = true;
    }
    if (!taxCode$.trim()) {
      this.validTaxCode = true;
    }
    if ((!address$ || address$ && !address$.trim()) && !this.form_create.value.addressNew) {
      this.validAddress = true;
    }
    if (this.validName || this.validenterpriseCode || this.validGlnCode || this.validTaxCode || this.validAddress || this.notDocuments) {
      return;
    }
    this.loading = true;
    const city$ = countryId$ === 'VN' ? this.form_create.value.city : 0;
    const district$ = countryId$ === 'VN' ? this.form_create.value.district : 0;
    const phone$ = this.form_create.value.phone;
    const email$ = this.form_create.value.email;
    const website$ = this.form_create.value.website;
    const avatar$ = this.form_create.value.avatar;
    const cover$ = this.form_create.value.cover;
    const documents$ = this.form_create.value.documents;
    const addressNew = this.form_create.value.addressNew;
    const provinceNewId = this.form_create.value.provinceNewId;
    const addressNewName = this.form_create.value.addressNewName;
    const wardNewId = this.form_create.value.wardNewId;
    const body = {
      name: capitalizeFirstLetter(removeAllSpacingBetweenWords(name$)),
      enterpriseCode: enterpriseCode$,
      glnCode: glnCode$,
      taxCode: taxCode$,
      // tslint:disable-next-line:radix
      countryId: parseInt(this.form_create.value.countryId.split('-')[0]),
      address: address$,
      provinceId: city$,
      districtId: district$,
      phone: phone$,
      email: email$,
      website: website$,
      avatar: avatar$,
      cover: cover$,
      documents: documents$,
      addressNew,
      provinceNewId,
      wardNewId,
      addressNewName
    };
    if (addressNew) {
      body.provinceId = null;
      body.districtId = null;
      body.address = null;
    } else {
      body.provinceNewId = null;
      body.wardNewId = null;
      body.addressNewName = null;
    }
    // console.log(body);
    this.codeService.create(body).subscribe(
      res => {
        this.loading = false;
        if (res.code === 1) {
          this.notification.create(
            'success',
            'Thành công',
            'Thêm mới mã doanh nghiệp thành công'
          );
          this.show = false;
          setTimeout(() => {
            this.emitData.emit(res.code);
          }, 1000);
          return;
        }

        this.notification.create(
          'error',
          'Thêm mới mã doanh nghiệp thất bại',
          res.message
        );
      },
      error => {

        this.loading = false;
        this.notification.create(
          'error',
          'Thêm mới mã doanh nghiệp thất bại',
          'Hệ thống đang nâng cấp.Vui lòng thử lại sau'
        );
      }
    );
  }

  // upload file
  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      }
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe(changeParam => {
        if (changeParam.type === 'success') {
          const data = {
            name: changeParam.file.name,
            type: changeParam.file.type,
            url: changeParam.file.response.url,
          };
          const body = {
            title: changeParam.file.name,
            type: changeParam.file.type,
            listUrl: [changeParam.file.response.url]
          };
          // avatar,cover
          this[field] = [];
          this[field].push(data);
          this.form_create.get(field).setValue(changeParam.file.response.url);
        }
      });
      modal.getContentComponent().done.pipe(takeUntil(this.unsubscribe$)).subscribe(changeParam => {
        modal.close();
      });
    });
  }

  onRemoveFile(field: string, index: number) {
    this[field].splice(index, 1);
    if (field === 'documents') {
      this.form_create.get(field).value.splice(index, 1);
    } else {
      this.form_create.get(field).setValue('');
    }
  }

  delete(file, index) {
    this.selectDocument.setId(this.files[index].documentId, false);
    this.files.splice(index, 1);
    if (!this.files.length) {
      this.notDocuments = true;
    }
  }

  getCountries() {
    this.rootService.listCountries().subscribe(
      res => {
        this.countries = res.data.items;
      },
      error => {
        this.countries = [];
      }
    );
  }

  getCities() {
    const response = this.rootService.listCities();
    response.subscribe(
      res => {
        this.cities = res.data.items;
      },
      error => {
        this.cities = [];
      }
    );
  }
  getDistrictsNew($event: any) {
    this.form_create.get('wardNewId').setValue(null);
  }
  getDistricts(event) {
    // tslint:disable-next-line:variable-name
    const district_id = this.form_create.get('district').value;
    if (district_id) {
      this.form_create.get('district').setValue('');
    }
    // tslint:disable-next-line:variable-name
    const province_id = event;
    if (province_id) {
      const response = this.rootService.listDistricts(province_id);
      response.subscribe(
        res => {
          this.districts = res.data.items;
        },
        error => {
          this.districts = [];
        }
      );
    }
  }

  showCreate() {


    this.notDocuments = false;
    this.show = true;
    this.files = [];
    this.avatar = [];
    this.cover = [];
    this.form_create.reset();
    this.form_create.get('addressNew').setValue(true);
    this.getCountries();
    this.getCities();
  }

  hideCreate() {
    this.loading = false;
    this.show = false;
    this.form_create.reset();
    this.files = [];
    this.avatar = [];
    this.cover = [];
    this.validName = false;
    this.validenterpriseCode = false;
    this.validGlnCode = false;
    this.validTaxCode = false;
    this.validAddress = false;

  }
}
